import { Injectable } from "@angular/core";
import { ITranslateObject, JobsBillingCard } from "../views-interfaces";
import { DateInputModel } from "@app/filter-menu/filter-types";
import { WkDateFormat } from "./date-format";

@Injectable({
    providedIn: "root",
})
export class DueOnFilterGeneratorService {
    generateModel(input: string) {
        return {
            label: "FiltersSidebar.Labels.DueOn",
            text: input,
            date: WkDateFormat.formatDate(input),
        } as DateInputModel;
    }

    getPrintDescription(label: string | ITranslateObject, selectedValue: string): { label: string | ITranslateObject; values: string[] } | null {
        if (!selectedValue || selectedValue.length === 0) {
            return null;
        } else {
            return {
                label,
                values: [selectedValue],
            };
        }
    }

    generateFilter(input: string) {
        if (!input || input.length === 0) {
            return null;
        } else {
            return (card: JobsBillingCard) => {
                // TODO card?.taxYearEndDate does not exist on a J&B card.
                //return card?.taxYearEndDate?.toLowerCase()?.indexOf(input?.toLowerCase()) > -1;
                throw "Not implemented";
            };
        }
    }
}
